import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import * as fromApp from "../../store/app.reducer";

import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import * as CartActions from "../../cart/store/cart.actions";
import { CalculateFinalPriceService } from "../calculateFinalPrice/calculate-final-price.service";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class ValidatingCartService {
  private store_info: any;
  private orderPickup: any;
  private cartProducts: any;
  private currentStoreId: string;
  private validatingCartLoading: boolean;
  private activeCoupons: any;
  constructor(
    private store: Store<fromApp.AppState>,
    private calcFinalPriceService: CalculateFinalPriceService,
    private router: Router
  ) {}

  validatingCartSubscriptions() {
    this.store
      .select("cart")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && !_.isEqual(this.cartProducts, state.products)) {
          this.cartProducts = _.cloneDeep(state.products);
        }
        if (
          state &&
          !_.isEqual(this.validatingCartLoading, state.validatingCartLoading)
        ) {
          this.validatingCartLoading = _.cloneDeep(state.validatingCartLoading);
        }
      });

    this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
          //console.log("order pickupChanged");
          this.orderPickup = _.cloneDeep(state.orderPickup);
          this.validateCartDebounce();
        }
      });

    this.store
      .select(selectors.getStoreInfo)
      .pipe(distinctUntilChanged())
      .subscribe((store_info) => {
        if (store_info && !_.isEqual(this.store_info, store_info)) {
          console.log("store info changed");
          this.store_info = _.cloneDeep(store_info);
          this.validateCartDebounce();
        }
      });

    this.store
      .select("currentStore")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (
          state &&
          state.currentStoreId &&
          !_.isEqual(this.currentStoreId, state.currentStoreId)
        ) {
          this.currentStoreId = _.cloneDeep(state.currentStoreId);
          this.validateCartDebounce();
        }
      });

    this.store
      .select("cartActiveCoupons")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && !_.isEqual(this.activeCoupons, state.activeCoupons)) {
          this.activeCoupons = _.cloneDeep(state.activeCoupons);
          this.validateCartDebounce();
        }
      });
  }

  validatingCart(cartProducts, store_info, orderPickup) {
    console.log(
      "validatingCartRun",
      store_info.store_name,
      store_info.store_id,
      cartProducts
    );

    const now = moment();
    const [freshProducts, expiredProducts] = _.partition(
      cartProducts || [],
      (p) => {
        const ts = Number(p.cart_id);
        if (!ts || Number.isNaN(ts)) return true;
        return now.diff(moment(ts), "hours") < 24;
      }
    );

    // Delete expired products only when not on cart page
    if (
      expiredProducts.length &&
      !(
        this.router &&
        this.router.url &&
        this.router.url.toString().includes("cart")
      )
    ) {
      cartProducts = freshProducts;

      if (navigator.cookieEnabled) {
        if (cartProducts.length) {
          window.localStorage.setItem("cart", JSON.stringify(cartProducts));
        } else {
          window.localStorage.removeItem("cart");
        }
      }

      // reflect removals in state
      this.store.dispatch(new CartActions.SetCartProducts(cartProducts));
    }

    // 2) Existing validations
    if (
      cartProducts &&
      cartProducts.length > 0 &&
      !_.find(cartProducts, { store_id: store_info.store_id })
    ) {
      if (navigator.cookieEnabled) {
        window.localStorage.removeItem("cart");
      }
      this.store.dispatch(new CartActions.ClearCart());
      this.store.dispatch(new CartActions.SetValidatingCartLoading(false));
      return;
    }

    if (
      cartProducts &&
      _.find(cartProducts, (produt) => {
        if (produt.product_coupon_timestamp) {
          return true;
        }
      }) &&
      (!this.activeCoupons || !this.activeCoupons.length)
    ) {
      console.log("before coupon products", cartProducts);
      // Checking for invalid pickup products
      cartProducts = _.filter(cartProducts, function (cartProduct) {
        return !cartProduct.product_coupon_timestamp;
      });

      console.log("after clearing coupon products", cartProducts);

      if (navigator.cookieEnabled) {
        window.localStorage.setItem("cart", JSON.stringify(cartProducts));
      }
      console.log("setting cart products to state");

      this.store.dispatch(new CartActions.SetCartProducts(cartProducts));
      this.store.dispatch(new CartActions.SetValidatingCartLoading(false));
    }

    this.store.dispatch(new CartActions.SetValidatingCartLoading(false));
  }

  validateCartDebounce = _.debounce(() => {
    console.log("debounce function called");
    if (!this.validatingCartLoading) {
      this.store.dispatch(new CartActions.SetValidatingCartLoading(true));
      console.log(
        "doubounce function attributes",
        this.store_info,
        this.cartProducts,
        this.orderPickup
      );
      if (
        this.store_info &&
        this.cartProducts

        //this.currentStoreId
      ) {
        console.log("inside if and calling validating cart from state");
        //console.log("validating attr", this.store_info, this.cartProducts);
        this.validatingCart(
          this.cartProducts,
          this.store_info,
          this.orderPickup
        );
      } else {
      }
    } else {
      this.store.dispatch(new CartActions.SetValidatingCartLoading(false));
      this.validateCartDebounce();
    }
  }, 200);
}
